import { mix, rgba } from 'polished';
import common from '@material-ui/core/colors/common';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

export const defaultColors = {
  lightGrey: '#F2F2F2',
  grey: mix(0.38, common.black, common.white),
  darkGrey: mix(0.87, common.black, common.white),
  white: common.white,
  black: common.black,
  red: '#FA3232',
  green: '#149632',
  lightBlue: '#777794',
};

const breakpoints = {
  keys: ['xs', 'sm', 'md', 'md-lg', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 600,
    md: 768,
    'md-lg': 960,
    lg: 1280,
    xl: 1920,
  },
};

export const BASIC_THEME_TWO_PAGES_BREAKPOINT_FALLBACK = breakpoints.values.md;

export default createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: [
      'Rubik',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    primary: {
      main: defaultColors.white,
    },
    secondary: {
      main: defaultColors.lightBlue,
    },
  },
  colors: {
    background: defaultColors.gray,
    disabled: rgba(defaultColors.black, 0.4),
    brand: defaultColors.black,
    pagesBg: defaultColors.lightGrey,
    ...defaultColors,
  },
  overrides: {
    MuiTypography: {
      caption: {
        color: rgba(defaultColors.black, 0.54),
      },
      h6: {
        lineHeight: '1.16667em',
      },
    },
  },
  // images: assets.reduce((acc, asset) => ({
  //   ...acc,
  //   [asset.name]: asset.url,
  // }), {
  //   arrowLeft: KeyboardArrowLeft,
  //   arrowRight: KeyboardArrowRight,
  // }),
  breakpoints,
});
